// Copyright (c) 2016 Deere & Company

import CreditMemoReport from './components/credit-memo-report';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const isReportCriteriaValid = (criteria, dealers) => dealers.length > 0 && [
    criteria.pin.length > 0,
    criteria.claimNumber.length > 0,
    criteria.creditMemo.length > 0,
    criteria.invoiceRequest.length > 0,
    criteria.workOrderOne.length > 0,
    criteria.dateIssued.from >= 0 || criteria.dateIssued.to >= 0
].some(rule => rule);

const getStateToBindToContainerProps = state => ({
    ...state.reports.creditMemo,
    columnApi: state.columnApi,
    gridApi: state.gridApi,
    isCriteriaValid: isReportCriteriaValid(state.reports.creditMemo.criteria, state.reports.creditMemo.selectedDealers),
    isDefaultColumnStateAvailable: state.reportVariant.layouts.length ? Boolean(state.reportVariant.layouts.find(layout => layout.name === '').columnState.length) : false,
    isInitialLoad: state.reportVariant.isInitialLoad,
    isReportColumnsVisible: state.reportVariant.isReportColumnsVisible,
    isSapUp: state.app.sapStatus.isSapUp,
    layouts: state.reportVariant.layouts,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts,
    selectedLayout: state.reportVariant.selectedLayout
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams, location} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        pathName: location.pathname,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(CreditMemoReport);



// WEBPACK FOOTER //
// ./src/reports/credit-memo/state-connector.js